import { FC } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useIntl } from 'react-intl'

import Dashboard from 'layouts/Dashboard'

const ROOT_PATH = '/offer'

// Layout for the Oferty section ("Panel Klienta 3.0" redesign).
// Desktop: offers grid on the root path, detail pages in a centered white card.
// Mobile: offers list on the root path, full-screen subpages elsewhere.
const OfferLayout: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { pathname } = useLocation()
  const { formatMessage } = useIntl()

  const title = formatMessage({ id: 'widgetOffer.title', defaultMessage: 'Oferty' })

  if (isDesktop) {
    return (
      <Dashboard noHeader disableGutters>
        <Box sx={{ backgroundColor: theme.r4r.greyBg, minHeight: '100vh' }}>
          <Box sx={{ maxWidth: '1220px', mx: 'auto', px: '40px', pb: '64px' }}>
            <Box
              sx={{
                pt: '28px',
                pb: '25px',
                borderBottom: `1px solid ${theme.r4r.greyLight}`
              }}>
              <Typography sx={{ fontSize: '24px', fontWeight: 700, color: theme.r4r.navy }}>
                {title}
              </Typography>
            </Box>
            <Box sx={{ pt: '24px' }}>
              {pathname !== ROOT_PATH ? (
                <Box
                  sx={{
                    maxWidth: '760px',
                    mx: 'auto',
                    backgroundColor: '#fff',
                    boxShadow: theme.r4r.cardShadow,
                    p: '28px'
                  }}>
                  <Outlet />
                </Box>
              ) : (
                <Outlet />
              )}
            </Box>
          </Box>
        </Box>
      </Dashboard>
    )
  }

  if (pathname === ROOT_PATH) {
    return (
      <Dashboard noHeader>
        <Box sx={{ backgroundColor: theme.r4r.greyBg, minHeight: '100vh', pb: '24px' }}>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 700,
              color: theme.r4r.navy,
              textAlign: 'center',
              pt: '18px',
              pb: '14px'
            }}>
            {title}
          </Typography>
          <Box sx={{ px: '16px' }}>
            <Outlet />
          </Box>
        </Box>
      </Dashboard>
    )
  }

  return <Outlet />
}

export default OfferLayout
